/* Header nach eulenschnitt.de, shopweit (15.10.2026)
 *
 * Erst nur für Blog-Beiträge gebaut, dann auf Dennis' Wunsch auf alle Seiten
 * übertragen („es zuckt noch auf den anderen").
 *
 * Das Theme heftet den Header ab 250 px Scrollweg oben an (.site-header--stuck) und
 * fährt ihn dabei ein. Hier bleibt der angeheftete Header per CSS verborgen
 * und kommt nur, solange hochgescrollt wird (.jd-header--da):
 *   runterscrollen → nichts zu sehen (kein Einfahren und wieder Wegfahren)
 *   hochscrollen   → eine Zeile Logo, Menü, Symbole (CSS in jd-design-2026.css)
 *   ganz oben      → Statusleiste, Toolbar, voller Header
 * Offene Menüs und Drawer und Tastaturfokus im Header halten ihn sichtbar.
 */
(function () {
  var header = document.getElementById('SiteHeader');
  if (!header || header.dataset.sticky !== 'true') return;

  var SCHWELLE = 8;     // px Bewegung, bevor die Richtung zählt
  var letzte = window.scrollY;
  var da = false;
  var geplant = false;

  function setze(v) {
    if (v === da) return;
    da = v;
    header.classList.toggle('jd-header--da', v);
  }

  function festhalten() {
    // :focus-visible statt activeElement — ein Mausklick auf einen Header-Link
    // ließe den Fokus sonst dort stehen, und der Header bliebe für immer sichtbar
    return document.documentElement.classList.contains('js-drawer-open') ||
      header.querySelector(':focus-visible, details[open]') !== null;
  }

  function pruefe() {
    geplant = false;
    var y = window.scrollY;
    var d = y - letzte;
    if (!header.classList.contains('site-header--stuck')) {
      setze(false);
      letzte = y;
      return;
    }
    if (festhalten()) {
      setze(true);
      letzte = y;
      return;
    }
    if (Math.abs(d) < SCHWELLE) return;
    setze(d < 0);
    letzte = y;
  }

  window.addEventListener('scroll', function () {
    if (!geplant) {
      geplant = true;
      requestAnimationFrame(pruefe);
    }
  }, { passive: true });
})();
